import { Injectable } from '@angular/core';
import { Router, CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree } from '@angular/router';
import { AuthService } from '../services/auth/auth.service';

@Injectable()
export class IsPermissionGuard implements CanActivate {

    constructor(private router: Router, private _auth: AuthService) { }

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean | UrlTree {
        const permissions: string[] = route.data?.['permissions'] || [];
        const profiles: string[] = route.data?.['profiles'] || [];

        // 1. Si tiene RBAC y hay permisos definidos, verificar con RBAC
        if (this._auth.hasRbac$.getValue() && permissions.length > 0) {
            const allowed = this._auth.hasAnyPermission(permissions);
            if (allowed) {
                return true;
            }
            const defaultRoute = this._auth.getDefaultRoute();
            console.warn(`[IsPermissionGuard] Acceso denegado (RBAC) a ${state.url} → redirigiendo a ${defaultRoute}`);
            return this.router.parseUrl(defaultRoute);
        }

        // 2. Fallback legacy: verificar perfiles
        if (profiles.length > 0) {
            const sessionUser = this._auth?.sessionUser?.profile || [];
            const hasProfile = sessionUser.some((elem: any) => profiles.includes(elem));
            if (hasProfile) {
                return true;
            }
            console.warn(`[IsPermissionGuard] Acceso denegado (legacy) — permaneciendo en vista actual`);
            return false;
        }

        // 3. Sin permisos ni perfiles requeridos, permitir acceso
        return true;
    }
}
